module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-0-Active-ClubPilates-a1068d4102c66f357c9da97bcd177ae8.png";